import { ITimer, Countdown, TimerService, NullTimer, Countup } from '../../services'

export class TimerFactory {
  private _registry: Map<string, (options) => ITimer> = new Map()

  public constructor() {
    this._registry.set('count_down', this._countDown)
    this._registry.set('count_up', this._countUp)
  }

  public create(type: string, options: {} = {}): ITimer {
    const nullStrategy = (_options) => new NullTimer()
    const strategy = this._registry.get(type) || nullStrategy
    return strategy.call(this, options)
  }

  public createBaseTimer(elapsedTime = 0): TimerService {
    return this._createTimerService(elapsedTime)
  }

  private _countDown(options): ITimer {
    return new Countdown(options.allottedTime, this._createTimerService(options.elapsedTime))
  }

  private _countUp(options): ITimer {
    return new Countup(this._createTimerService(options.elapsedTime))
  }

  private _createTimerService(elapsedTime = 0): TimerService {
    return new TimerService(elapsedTime)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/factories/timer/timer.factory.ts